<template>
  <div>
    <b-container fluid class="gen-header">
      <b-row>
        <b-col sm="12">
          <div class="childs">
            <div class="page-title">About Us</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <about-us-page></about-us-page>
    <call-us></call-us>
  </div>
</template>

<script>
// @ is an alias to /src
import AboutUsPage from "@/components/AboutUsPage.vue";
import CallUs from "@/components/CallUs.vue";

export default {
  created() {
    document.title = "About Us";
  },
  name: "About",
  data() {
    return {
      // drawer: true,
      images: {
        headImage: require("@/assets/bgparallax-01.jpg")
      },
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "About Us",
          active: true
        }
      ]
    };
  },
  components: {
    "about-us-page": AboutUsPage,
    "call-us": CallUs
  }
};
</script>
<style scoped></style>
